"use strict";
// Border Block property parser
// Handles parsing of CSS border-block shorthand property
// https://developer.mozilla.org/en-US/docs/Web/CSS/border-block
Object.defineProperty(exports, "__esModule", { value: true });
exports.parse = parse;
exports.toCSSValue = toCSSValue;
const shared_logical_border_1 = require('./shared-logical-border.cjs');
/**
 * Parses a CSS border-block property string into BorderBlockValue
 * @param value - The CSS border-block property value
 * @returns Parsed border-block object or null if invalid
 */
function parse(value) {
    return (0, shared_logical_border_1.parseLogicalBorderProperty)(value);
}
/**
 * Converts a BorderBlockValue back to a CSS string
 * @param parsed - The parsed border-block object
 * @returns CSS string representation
 */
function toCSSValue(parsed) {
    return (0, shared_logical_border_1.logicalBorderToCSSValue)(parsed);
}
